<script lang=ts setup>
import { computed, ref } from "vue";
import playButton from "./play-button.vue";
import type { FormWidgetData } from "../../../../widgetDataTs.js";
import { isString, type Nil } from "@mcwd/typescript-type-guards";

const props = defineProps<{
  widgetData: FormWidgetData<"VideoForm" | "GatedVideoForm">;
  customData?: Record<string, any> | undefined;
}>();

const videoData = computed(() => {
  return props.widgetData.setup.form.video.selected;
});

const data = props.customData as { thumbnail?: string | Nil };
const noKey = ref(false);

const genericThumbUrl = "https://static.mastercontrol.com/assets/persist/images/video-thumbnail-generic.jpg";

const thumbnailUrl = computed(() => {
  if (isString(data?.thumbnail) && data.thumbnail.trim() === "") {
    return genericThumbUrl;
  }
  return data?.thumbnail ?? genericThumbUrl;
})

</script>

<template>
  <div class="main-content">
    <div class="video-wrpr col-12" :class="{ 'no-key': noKey }">
      <div class="video-lid">
        <!-- No Gate Click -->
        <slot name="no-gate-video"></slot>

        <!-- Video Thumbnail -->
        <div class="video-thumb" :style="'background-image: url(' + thumbnailUrl + ');'"></div>
        <!-- video gradient-bg -->
        <div class="video-gradient-bg vid-space"></div>
        <!-- Video Timer -->
        <div class="video-timer">
          {{ videoData.runtime }}
        </div>
        <!-- Video Top -->
        <div class="video-top vid-space">
          <playButton />
          <p class="title">
            Please complete the form for instant access to this video.
          </p>
        </div>
        <!-- The Form -->
        <slot name="resource-form"></slot>
      </div>

      <!-- Video on Form Success -->
      <div id="video-success">
        <div id="yt-iframe">
          <!-- The iframe loads here -->
        </div>
      </div>
    </div>
  </div>
</template>
